<vsf-collection-breadcrumbs
    [breadcrumbs]='breadcrumbs'
    [linkLast]='false'
></vsf-collection-breadcrumbs>
<div class='max-w-7xl mx-2 xl:mx-auto mt-4 px-1 sm:px-4 2xl:px-0' [class]='product ? "transition-opacity duration-500 opacity-100": "opacity-60"'>
    <ng-container [ngSwitch]='pageType$ | async'>
        <kb-product-page-color-chart
            *ngSwitchCase="'colour-chart'"
            [productPreview]='productPreview$ | async'
            [product]='product$ | async'
            (addToCartClick)='addToCart($event)'
            (updateOrderLineClick)='updateOrderLine($event)'
            (addToWishlistClick)='addToWishlist($event)'
        ></kb-product-page-color-chart>
        <kb-product-page-gift-card
            *ngSwitchCase="'gift-card'"
            [product]='product$ | async'
            [productPreview]='productPreview$ | async'
        ></kb-product-page-gift-card>
        <kb-product-page-select-menu
            *ngSwitchCase="'select-menu'"
            [productPreview]='productPreview$ | async'
            [product]='product$ | async'
            (addToCartClick)='addToCart($event)'
            (updateOrderLineClick)='updateOrderLine($event)'
            (addToWishlistClick)='addToWishlist($event)'
        ></kb-product-page-select-menu>
        <kb-product-page-default
            *ngSwitchDefault
            [productPreview]='productPreview$ | async'
            [product]='product$ | async'
            (addToCartClick)='addToCart($event)'
            (updateOrderLineClick)='updateOrderLine($event)'
            (addToWishlistClick)='addToWishlist($event)'
        ></kb-product-page-default>
    </ng-container>

    <kb-json-ld [json]='jsonLdData$ | async'></kb-json-ld>
</div>

<kb-product-recommendations [productId]='(product$ | async)?.id'></kb-product-recommendations>

<kb-blog-feed
    class='block'
    title='Related blog posts'
    [showRelatedTags]='true'
    [tagIds]='relatedBlogPostIds'
></kb-blog-feed>


<div class='bg-gray-50'>
    <kb-top-reviews
        *ngIf='product'
        [reviewsData]='product.reviews'
        [histogramData]='product.reviewsHistogram'
        [rating]='product.customFields.reviewRating'
    ></kb-top-reviews>
</div>

<ng-template #addedToCartTemplate let-variant='variant' let-quantity='quantity' let-close='closeFn'>
    <div class='flex items-center'>
        <div class='mr-2'>
            <img
                class='rounded-sm'
                [src]="(variant.featuredAsset?.preview || product?.featuredAsset?.preview) + '?preset=tiny'"
                alt='product thumbnail'
            />
        </div>
        <div class='text-gray-700 text-sm'>{{ quantity }} x {{ variant.name }}</div>
    </div>
    <div class='text-center mt-4'>
        <button class='btn w-full' (click)='viewCartFromNotification(close)'>
            View cart
        </button>
    </div>
</ng-template>

<ng-template #addedToWishlistTemplate let-variant='variant' let-close='closeFn' let-wishlistId='wishlistId'>
    <div class='flex items-center'>
        <div class='mr-2'>
            <img
                class='rounded-sm'
                [src]="(variant.featuredAsset?.preview || product?.featuredAsset?.preview) + '?preset=tiny'"
                alt='product thumbnail'
            />
        </div>
        <div class='text-gray-700 text-sm'>
            {{ variant.name }}
        </div>
    </div>
    <div class='mt-4'>
        <a
            class='btn w-full block text-center'
            [routerLink]="['/wishlist', wishlistId || '']"
            (click)='close()'
        >View wishlist</a
        >
    </div>
</ng-template>
